import { MD5 } from 'crypto-js';
import React, { useEffect, useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { DownloadIconLine } from '../../../../utils/SVGIcon';
import { GetDateFromISOWithTime } from '../../../../utils/Show';
import cn from '../../../../utils/cn';
import { getFileIcon } from '../../../../utils/getFileIcon';
import { handleGetGithubReleasesListOpe } from '../SubscriptionsDetailsOpe';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';

function ReleasesItem({ data, isFirstItem }) {
    return (
        <div
            className={cn(
                'releases-item flex flex-col gap-1 w-full border border-primary-200 rounded-lg bg-white p-5',
                {
                    'placeholder-mode': data?.demo
                }
            )}
        >
            <h1 className="releases-title flex justify-start items-center gap-[9px]">
                <span className="text-[25px] font-medium text-primary">{data?.name}</span>
                {!data?.demo && isFirstItem && (
                    <span className="latest-tag text-[#00916E] py-0.5 px-[7px] border border-[#00916E] rounded">
                        Latest
                    </span>
                )}
            </h1>
            <div className="releases-info flex flex-col gap-1.5">
                <p className="releases-version text-sm font-normal flex justify-start items-center gap-1">
                    <span className="text-primary-700">Version:</span>
                    <span className="text-primary">{data?.tagName}</span>
                </p>
                <p className="releases-date text-sm font-normal flex justify-start items-center gap-1">
                    <span className="text-primary-700">Published on:</span>
                    <span className="text-primary">
                        {GetDateFromISOWithTime(data?.publishedAt)}
                    </span>
                </p>
                <p className="releases-description text-sm font-normal flex justify-start items-center gap-1">
                    <span className="text-primary-700">Release Note:</span>
                    <span className="text-primary">
                        {data?.body ? data?.body : 'No release note provided.'}
                    </span>
                </p>
            </div>
            <div className="releases-files flex justify-start items-center gap-4">
                <span className="text-primary-700">Assets:</span>
                <ul className="flex gap-2.5 *:bg-primary-50 *:pr-2 *:py-1.5 *:pl-[5px] *:rounded-md *:text-primary">
                    {data?.assets?.map((item, index) => (
                        <li key={MD5(index)} className="relative group">
                            <a
                                href={item?.browserDownloadUrl}
                                target="_blank"
                                className={cn(
                                    'absolute top-0 left-0  text-white bg-secondary inline-flex gap-2.5 justify-center items-center w-full h-full opacity-0 group-hover:opacity-100 rounded-md transition-opacity ease-in-out duration-200'
                                )}
                                rel="noreferrer"
                            >
                                <span>Download</span>
                                <span className="size-[15px] text-[#f9f9f9]">
                                    <DownloadIconLine />
                                </span>
                            </a>
                            <div className="flex items-center gap-1 cursor-pointer">
                                <span className="inline-block size-5.5">{getFileIcon('zip')}</span>
                                <span>{item.name}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

function ViewGithubReleases() {
    const { subscriptionsDetailsData } = useSubscriptionsDetails();
    const demoData = [
        {
            id: 136981407,
            name: 'Test Release 2',
            tagName: 'v2.11',
            publishedAt: '2024-01-14T14:11:08Z',
            demo: true
        }
    ];

    const [releasesFile, setReleasesFile] = useState(demoData || []);
    const { setMessage } = useTemplate();

    useEffect(() => {
        handleGetGithubReleasesListOpe(subscriptionsDetailsData?.id)
            .then(({ data }) => {
                setReleasesFile(data.releases);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.toString(0) });
            });
    }, [setMessage, subscriptionsDetailsData]);

    return (
        <div className="releases-item-list my-5 mx-2 flex flex-col justify-start items-center gap-2.5">
            {releasesFile &&
                releasesFile?.map((item, index) => (
                    <ReleasesItem key={item.id} data={item} isFirstItem={index === 0} />
                ))}
        </div>
    );
}

export default ViewGithubReleases;
